// @flow

import {Environment} from 'relay-runtime'
import {commitMutation, graphql, } from 'react-relay'

const mutation = graphql`
    mutation PasswordMutation(
        $input: ChangePasswordInput!
    ) {
        ChangePassword(input: $input) {
            error,
            clientMutationId
        }
    }
`

export function commit(environment: Environment, params: any, callback: (error: ?string, value: ?string) => void) {
    const { oldPassword, password } = params
    commitMutation(
        environment, 
        {
            mutation: mutation,
            variables: {
                input: {
                    oldPassword: oldPassword,
                    password: password,
                }
            },
            onCompleted: (response) =>{
                console.log("mutation complete")
                console.log(response)
                if (response.ChangePassword.error != null) {
                    callback(response.ChangePassword.error, null)
                } else {
                    callback(null, response.ChangePassword.clientMutationId)
                }
            },
            onError: (error) => {
                console.log("error mutating")
                console.log(error)
                callback(error, null)
            },
        })
}


// WEBPACK FOOTER //
// src/mutations/PasswordMutation.js